<template>
  <fts-design-modal
    width="1024px"
    class="fts-module-create-modal"
    append-header-class="module-create-modal__header"
    append-content-class="module-create-modal__body"
    @closed="reset"
    ref="ftsModuleCreateModal"
  >
    <!-- header -->
    <template #header>
      <fts-btn lg text icon @click="close">
        <font-awesome-icon :icon="['fas', 'times']" />
      </fts-btn>
    </template>
    <!-- body -->
    <template #body>
      <div class="design-modal-content__header">
        <div class="design-modal-content__header-title">
          Create a new module for your business app
        </div>
        <div class="design-modal-content__header-description">
          It can be a process or a workflow like ticketing, approval, or leave application. <br/>
          Or, it can be a collection of entries like employees, products or customers
        </div>
      </div>

      <div class="module-create-select-container">
        <!-- module -->
        <div class="module-create-select" @click="createModule">
          <font-awesome-icon :icon="['fas', 'plus']" class="module-create-select-icon" />
          <div class="module-create-select-title">
            Create
          </div>
          <div class="module-create-select-description">
            Build from scratch.
          </div>
        </div>
        <!-- template -->
        <div class="module-create-select" @click="createModuleWithTemplate">
          <font-awesome-icon :icon="['far', 'file-alt']" class="module-create-select-icon" />
          <div class="module-create-select-title">
            Template
          </div>
          <div class="module-create-select-description">
            Choose a similar template, use or make improvements from there.
          </div>
        </div>
        <!-- spreadsheet -->
        <div class="module-create-select" @click="createModuleWithSpreadsheet">
          <font-awesome-icon :icon="['fas', 'table']" class="module-create-select-icon" />
          <div class="module-create-select-title">
            Spreadsheet
          </div>
          <div class="module-create-select-description">
            Convert your existing spreadsheet into app with single click.
          </div>
        </div>
      </div>

      <div class="module-create-content__footer">
        <fts-btn text @click="close">
          Cancel
        </fts-btn>
      </div>
    </template>
  </fts-design-modal>
</template>

<script>
import FTSDesignModal from "./FTSDesignModal";
import FTSBtn from "../elements/FTSBtn";

export default {
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-btn": FTSBtn,
  },
  data: () => ({
    resolve: null,
  }),
  methods: {
    async show() {
      return new Promise((resolve) => {
        this.resolve = resolve;
        this.$refs.ftsModuleCreateModal.show();
      }); 
    },
    close() {
      this.$refs.ftsModuleCreateModal.close();
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    createModule() {
      this.resolve && this.resolve('create');
      this.close();
    },
    createModuleWithTemplate() {
      this.resolve && this.resolve('template');
      this.close();
    },
    createModuleWithSpreadsheet() {
      this.resolve && this.resolve('spreadsheet');
      this.close();
    },
  },
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-module-create-modal {
  .module-create-modal__header {
    justify-content: flex-end;
    padding: .75rem;
  }
  .module-create-modal__body {
    padding: 0 1rem 1.5rem;
  }
  .module-create-select-container {
    display: grid;
    gap: 2rem;
    margin-bottom: 2rem;
    margin-left: 1rem;
    margin-right: 1rem;
    .module-create-select {
      padding: 2rem;
      border-radius: .5rem;
      background-color: var(--fts-primary-light);
      background-size: cover;
      background-image: url("../../assets/images/studio/mesh-gradient.png");
      text-align: center;
      cursor: pointer;
      &:hover {
        .module-create-select-icon,
        .module-create-select-title {
          color: var(--fts-secondary);
        }
      }
      .module-create-select-icon {
        margin-bottom: 1rem;
        font-size: 2.5rem;
        color: var(--fts-primary);
      }
      .module-create-select-title {
        margin-bottom: .5rem;
        font-weight: 500;
        font-size: 1.25rem;
        line-height: 1.75rem;
        color: var(--fts-primary);
      }
      .module-create-select-description {
        font-size: .875rem;
        line-height: 1.25rem;
      }
    }
  }
  .module-create-content__footer {
    margin-left: 1rem;
    margin-right: 1rem;
    text-align: right;
  }
  /* to-do utilities.scss */
  @media (min-width: 768px) {
    .module-create-select-container {
      grid-template-columns: repeat(2,minmax(0,1fr));
    }
  }
  @media (min-width: 1024px) {
    .module-create-select-container {
      grid-template-columns: repeat(3,minmax(0,1fr));
    }
  }
}
</style>